import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["src", "alt"];
const _hoisted_2 = { class: "p-4 flex-1 min-w-0" };
const _hoisted_3 = { class: "font-semibold text-gray-900" };
const _hoisted_4 = {
    key: 0,
    class: "text-sm text-gray-600 mt-1 line-clamp-2"
};
const _hoisted_5 = { class: "flex items-center justify-between mt-3" };
const _hoisted_6 = { class: "text-lg font-bold text-gray-900" };
const _hoisted_7 = {
    key: 0,
    class: "text-xs font-medium bg-green-100 text-green-800 px-2 py-1 rounded-full"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuCard',
    props: {
        menu: {},
        imagePosition: { default: 'above' },
        imageMaxHeightPercent: { default: 100 }
    },
    emits: ["select"],
    setup(__props) {
        const props = __props;
        const savingsCent = computed(() => props.menu.referenceSavingsCent || 0);
        const hasImage = computed(() => Boolean(props.menu.imageUrl || props.menu.image));
        const clampedPercent = computed(() => Math.max(0, Math.min(100, props.imageMaxHeightPercent ?? 100)));
        const showImage = computed(() => hasImage.value && clampedPercent.value > 0);
        const positionClass = computed(() => {
            switch (props.imagePosition) {
                case 'left':
                    return 'flex-row';
                case 'right':
                    return 'flex-row-reverse';
                default:
                    return 'flex-col';
            }
        });
        const mediaClass = computed(() => props.imagePosition === 'above' ? 'w-full' : 'w-2/5 max-w-[45%]');
        // aspect-ratio = Breite/Höhe. 100 % → 1 (quadratisch), 50 % → 2 (halbe Höhe).
        const mediaStyle = computed(() => ({
            aspectRatio: String(100 / Math.max(clampedPercent.value, 1))
        }));
        const formatPrice = (cent) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["menu-card bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden cursor-pointer hover:shadow-md transition-shadow flex", positionClass.value]),
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('select', _ctx.menu)))
            }, [
                (showImage.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["menu-card__media bg-gray-100 flex-shrink-0 overflow-hidden", mediaClass.value]),
                        style: _normalizeStyle(mediaStyle.value)
                    }, [
                        _createElementVNode("img", {
                            src: _ctx.menu.imageUrl,
                            alt: _ctx.menu.name,
                            class: "w-full h-full object-cover"
                        }, null, 8 /* PROPS */, _hoisted_1)
                    ], 6 /* CLASS, STYLE */))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.menu.name), 1 /* TEXT */),
                    (_ctx.menu.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.menu.description), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(formatPrice(_ctx.menu.menuPriceCent)), 1 /* TEXT */),
                        (savingsCent.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Spare " + _toDisplayString(formatPrice(savingsCent.value)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ], 2 /* CLASS */));
        };
    }
});
